import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-[80vh] flex items-center justify-center bg-brand-ivory">
      <div className="text-center max-w-md px-6">
        <div className="font-serif text-8xl text-brand-gold">404</div>
        <h1 className="font-serif text-4xl mt-6 text-brand-charcoal">This page has moved.</h1>
        <p className="mt-4 text-brand-charcoal/60 leading-relaxed">The link you followed may be outdated. Head back home to explore our catalogue.</p>
        <Link to="/" className="mt-10 luxe-btn-outline text-brand-green border-brand-green hover:bg-brand-green hover:text-brand-ivory inline-flex" data-testid="notfound-home">
          <ArrowLeft className="w-4 h-4" /> Back to Home
        </Link>
      </div>
    </section>
  );
}
